import { combineReducers } from 'redux';
import theme from './redux-theme';

export default combineReducers({ theme });
